@let currentRealisation = realisation();
@let currentForm = form();
@let beginTime = currentForm.controls.begindate.value;
@let endTime = currentForm.controls.enddate.value;
@let isMarkedForRemoval = !!currentForm.controls.removed.value;

<div
    class="time fw-bold lh-1 mt-3 curpoint"
    [class.pe-none]="notEditable() || isMarkedForRemoval"
    [matTooltipDisabled]="
        (currentRealisation | isTraveltime) ||
        !(currentRealisation | doesNotMatchDriver: driverRealisations() : 'begindate' : beginTime)
    "
    [class.difference]="
        !(currentRealisation | isTraveltime) &&
        (currentRealisation | doesNotMatchDriver: driverRealisations() : 'begindate' : beginTime)
    "
    (click)="editTime($event, 'begindate', -1)"
    matTooltip="Geplande tijd: {{ currentRealisation.user_planning?.begindate | date: 'HH:mm' }}{{
        currentRealisation.planning_has?.begindate | date: 'HH:mm'
    }}">
    {{ beginTime | date: 'HH:mm' }}
</div>

<div
    class="project between d-flex flex-column align-content-center justify-content-center"
    [class.pe-auto]="notEditable() && !isMarkedForRemoval"
    [class.pe-none]="isMarkedForRemoval">
    @if (currentRealisation.hourtype !== RealisationHourtype.worktime) {
        <div class="top flex-shrink-0 text-center px-2">
            {{ currentRealisation.hourtype | hourtype }}
        </div>
    }

    @if (currentRealisation.leave) {
        <div class="bottom d-flex flex-shrink-0 align-items-center text-center fw-bold">
            {{ currentRealisation.leave?.comment }}
        </div>
    }

    @if (
        projectId() ||
        currentRealisation.planning?.worknumber ||
        projectName() ||
        currentRealisation.planning?.contractor
    ) {
        <div class="d-flex flex-column">
            @if (projectId() || currentRealisation.planning?.worknumber) {
                <div
                    class="bottom d-flex flex-shrink-0 align-items-center text-center fw-bold curpoint"
                    (click)="editProject($event)"
                    matTooltip="Klik om project aan te passen">
                    {{ projectId() ?? currentRealisation.planning?.worknumber }}
                </div>
            }

            @if (projectName() || currentRealisation.planning?.contractor) {
                <div class="top flex-shrink-0 text-center px-2">
                    {{ projectName() ?? currentRealisation.planning?.contractor }}
                </div>
            }
        </div>
    }
</div>

<div
    class="time fw-bold lh-1 mt-3 text-end curpoint"
    [class.pe-none]="notEditable() || isMarkedForRemoval"
    [matTooltipDisabled]="
        (currentRealisation | isTraveltime) ||
        !(currentRealisation | doesNotMatchDriver: driverRealisations() : 'enddate' : endTime)
    "
    [class.difference]="
        !(currentRealisation | isTraveltime) &&
        (currentRealisation | doesNotMatchDriver: driverRealisations() : 'enddate' : endTime)
    "
    (click)="editTime($event, 'enddate', 1)"
    matTooltip="Geplande tijd: {{ currentRealisation.user_planning?.enddate | date: 'HH:mm' }}{{
        currentRealisation.planning_has?.enddate | date: 'HH:mm'
    }}">
    {{ endTime | date: 'HH:mm' }}
</div>
